<template>
<div style="overflow:hidden">
    <div class='wrapper'>
     
        <div class="course_info">
            <div class="head" >
                <div @click="$router.go(-1)">
                    <img src="../../assets/images/course_2.0/返回.png" alt="">
                </div>
                <div>课堂反馈</div>
                <div></div>
            </div>
            <div>
                <div>备课包名称：{{$route.query.name}}</div>
                <div class="course_AVG">
                    <div style="display:flex">
                        <div>自我评价：</div> 
                        <el-rate
                            v-model="self_avg"
                            disabled
                           
                            text-color="#ff9900"
                            score-template="{value}">
                        </el-rate>
                    </div>
                     <div style="display:flex">
                        <div>老师评价：</div> 
                        <el-rate
                            v-model="teacher_avg"
                            disabled
                           
                            text-color="#ff9900"
                            score-template="{value}">
                        </el-rate>
                    </div>
                     <div style="display:flex">
                        <div>班级评价：</div> 
                        <el-rate
                            v-model="partner_avg"
                            disabled
                           
                            text-color="#ff9900"
                            score-template="{value}">
                        </el-rate>
                    </div>
                </div>
                
            </div>
        </div>
        <div class="head_tap">
                <div></div>
                <div :class='{active_head_color:active_head==1}' @click="active_head=1">学生评价<span style="color:#FF9B36">（{{list.length}}）</span> </div>
                <div :class='{active_head_color:active_head==2}' @click="active_head=2">导学案反馈 <span style="color:#FF9B36">（{{list_guidance.length}}）</span> </div>
                <div></div>
            </div>
       <div class="report_content" >
           
            <div class="chart_box" v-show="active_head==1">
                <div class="chart_item">
                    <!-- <div>自我评价</div> -->
                    <div id='my_evaluate' ></div>
                </div>
                <div class="chart_item">
                    <!-- <div>老师评价</div> -->
                    <div id='teacher_evaluate'></div>
                  
                </div>
                <div class="chart_item">
                    <!-- <div>同学评价</div> -->
                    <div id='classmate_evaluate'></div>
                </div>
            </div>
            <div class="student_list" v-show="active_head==1">
                <div>
                    <h3>评价列表</h3>
                </div>
                <div class="student_list_box">
                     <div class="student_item" v-for="(item,index) in list" :key="index">
                        <div style="display:flex;justify-content: space-between;color:#54A9FD">
                            <div> {{item.name}}</div>
                            <div>{{TimestampToTime_ss(item.createtime)}}</div>
                        </div>
                        <div class="item_box">
                               <div style="display:flex">
                                <div>自我评价：</div> 
                                <el-rate
                                    v-model="JSON.parse(item.content).self.score"
                                    disabled
                                 
                                    text-color="#ff9900"
                                    score-template="{value}">
                                </el-rate>
                            </div>
                            <div v-if="JSON.parse(item.content).self.txt" class="item_data_list">
                                <div v-for="(data,i) in JSON.parse(item.content).self.txt" :key="'ii'+i">
                                    {{data}}
                                </div>
                            </div>
                        </div>
                        <div class="item_box">
                               <div style="display:flex">
                                <div>老师评价：</div> 
                                <el-rate
                                    v-model=" JSON.parse(item.content).teacher.score"
                                    disabled
                                 
                                    text-color="#ff9900"
                                    score-template="{value}">
                                </el-rate>
                            </div>
                            <div v-if="JSON.parse(item.content).teacher.txt" class="item_data_list">
                                <div v-for="(data,i) in JSON.parse(item.content).teacher.txt" :key="'ii'+i">
                                    {{data}}
                                </div>
                            </div>
                        </div>
                        <div class="item_box">
                               <div style="display:flex">
                                <div>同学评价：</div> 
                                <el-rate
                                    v-model="JSON.parse(item.content).partner.score"
                                    disabled
                                 
                                    text-color="#ff9900"
                                    score-template="{value}">
                                </el-rate>
                            </div>
                            <div v-if="JSON.parse(item.content).partner.txt" class="item_data_list">
                                <div v-for="(data,i) in JSON.parse(item.content).partner.txt" :key="'ii'+i">
                                    {{data}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>
            <div v-show="active_head==2" class="list_gui_box">
                <div v-for="(item,index) in list_guidance" :key="index" class="list_gui_item">
                    <div class="list_gui_item_name">{{item.name}}</div>
                    <div class="list_gui_item_contnet">{{item.guidance_comment}}
                  
                    </div>
                    <div class="list_gui_item_time">{{TimestampToTime_ss(item.createtime)}}</div>
                </div>
            </div>
 

       </div>
        
    </div>
</div>
</template>
<script>
import echarts from 'echarts'
import {TimestampToTime_ss} from '../../config/common'
export default {
  
    data() {
    return {
        self_avg:0,
        teacher_avg:0,
        partner_avg:0,
        active_head:1,
        list:[],
        list_guidance:[]

    };
    },
    mounted() {
    //   this.drawPieChart()
       this.get_student_evaluate()
       this.get_guidance_evaluate()
    },
    methods: {
        TimestampToTime_ss(data){
          return  TimestampToTime_ss(data)
        },
        // 获取导学案评价
        get_guidance_evaluate(){
              let formdata=new FormData()
            formdata.append('id',this.$route.query.id)

            this.axios.post("/school/Course_Usages/guidanceCommentList", formdata).then(res => {
                console.log(res)
                this.list_guidance=res.data.data.data
            })
        },
        //获取学生评价
        get_student_evaluate(){
           let formdata=new FormData()
            formdata.append('course_batch_id',this.$route.query.id)

            this.axios.post("/school/Course_Usages/CourseCommentList", formdata).then(res => {
                 
                 if(res.data.code==1){
                    //  console.log(res.data.data.data)
                        let arr=res.data.data.data
                        let self_data=[ 
                                    {value: 0, name: '上课集中力'},
                                    {value: 0, name: '课程内容理解棒'},
                                    {value: 0, name: '效率变高'},
                                    {value: 0, name: '上课激情'}
                                ]
                        let teacher_data=[
                                    {value: 0, name: '作业效率高'},
                                    {value: 0, name: '不迟到、不拖堂'},
                                    {value: 0, name: '作业量适中'},
                                  
                        ]
                        let partner_data=[
                            {value: 0, name: '课堂气氛活跃'},
                                    {value: 0, name: '配合度高'},
                                    {value: 0, name: '没有迟到早退'},
                                    {value: 0, name: '精力集中'},
                        ]
                        for(let i in arr){
                            let content
                            try {
                                 content=JSON.parse(arr[i].content)
                            } catch (error) {
                                 content={}
                            }
                            //  console.log(content)
                             if(!content.self.txt){
                                 content.self.txt=[]
                             }
                             if(!content.teacher.txt){
                                 content.teacher.txt=[]
                             }
                             if(!content.partner.txt){
                                 content.partner.txt=[]
                             }
                            this.self_avg+=Number((content.self.score/arr.length).toFixed(2))
                            this.teacher_avg+=Number((content.teacher.score/arr.length).toFixed(2))
                            this.partner_avg+=Number((content.partner.score/arr.length).toFixed(2))
                            
                                if(content.self.txt.indexOf('上课集中力')){
                                    self_data[0].value++
                                }
                                if(content.self.txt.indexOf('课程内容理解棒')){
                                    self_data[1].value++
                                }
                                 if(content.self.txt.indexOf('效率变高')){
                                    self_data[2].value++
                                }
                                 if(content.self.txt.indexOf('上课激情')){
                                    self_data[3].value++
                                }
                                  if(content.teacher.txt.indexOf('作业效率高')){
                                    teacher_data[0].value++
                                }
                                 if(content.teacher.txt.indexOf('不迟到、不拖堂')){
                                    teacher_data[1].value++
                                }
                                 if(content.teacher.txt.indexOf('作业量适中')){
                                    teacher_data[2].value++
                                }
                                 if(content.partner.txt.indexOf('课堂气氛活跃')){
                                    partner_data[0].value++
                                }
                                if(content.partner.txt.indexOf('配合度高')){
                                    partner_data[1].value++
                                }
                                 if(content.partner.txt.indexOf('没有迟到早退')){
                                    partner_data[2].value++
                                }
                                 if(content.partner.txt.indexOf('精力集中')){
                                    partner_data[3].value++
                                }
                 

                           
                        }
                        this.drawPieChart(self_data)
                        this.drawPieChart_teacher(teacher_data)
                        this.drawPieChart_classmate(partner_data)
                        this.list=arr

                 }else{
                      this.$message({
                         message:res.data.msg,
                         type:'error',
                         durtion:1500,
                     })
                 }
            })
        },
        //获取导学案评价
      
        //生成饼图 自我评价
        drawPieChart(self_data) {
       
            let data=self_data
            //  console.log(data)
            this.chartPie = echarts.init(document.getElementById('my_evaluate'));
            this.chartPie.setOption({
           
                title:{
                    text: '自我评价',
                    // subtext: '纯属虚构',
                    left: 'center',
                    textStyle:{
                        // fontStyle:'20',
                        // fontWeight:'none',
                        lineHeight:'60'
                    }
                },
                grid:{
     

                },
                tooltip: {
                    top:0,
                    trigger: 'item'
                },
                legend: {
                    // orient: 'vertical',
                    // left: 'left',
                    bottom: '10px',
                    left: 'center'
                },
                series: [
                    {
                        name: '自我评价',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: '20',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: data,
                        itemStyle: {
                            normal:{
                                color:function(params) {
                                //自定义颜色
                                    let colorList = [          
                                        '#69B4FF','#FF9B36','#E37CFD','#FF3945'
                                    ];  //定义颜色列表 方便不等长选项自行截取
                                    return colorList[params.dataIndex]
                                    }
                            }
                        }
                    }
                ]
            })
            // option && myChart.setOption(option);
        },
        //生成饼图 老师评价
        drawPieChart_teacher(self_data) {
       
            let data=self_data
            //  console.log(data)
            this.chartPie_teacher = echarts.init(document.getElementById('teacher_evaluate'));
            this.chartPie_teacher.setOption({
           
                title:{
                    text: '老师评价',
                    // subtext: '纯属虚构',
                    left: 'center',
                    textStyle:{
                        // fontStyle:'20',
                        // fontWeight:'none',
                        lineHeight:'60'
                    }
                },
                grid:{
     

                },
                tooltip: {
                    top:0,
                    trigger: 'item'
                },
                legend: {
                    // orient: 'vertical',
                    // left: 'left',
                    bottom: '10px',
                    left: 'center'
                },
                series: [
                    {
                        name: '老师评价',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: '20',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: data,
                        itemStyle: {
                            normal:{
                                color:function(params) {
                                //自定义颜色
                                    let colorList = [          
                                        '#69B4FF','#FF9B36','#E37CFD','#FF3945'
                                    ];  //定义颜色列表 方便不等长选项自行截取
                                    return colorList[params.dataIndex]
                                    }
                            }
                        }
                    }
                ]
            })
            // option && myChart.setOption(option);
        },
        //生成饼图
        drawPieChart_classmate(self_data) {
       
            let data=self_data
            //  console.log(data)
            this.chartPie_classmate = echarts.init(document.getElementById('classmate_evaluate'));
            this.chartPie_classmate.setOption({
           
                title:{
                    text: '自我评价',
                    // subtext: '纯属虚构',
                    left: 'center',
                    textStyle:{
                        // fontStyle:'20',
                        // fontWeight:'none',
                        lineHeight:'60'
                    }
                },
                grid:{
     

                },
                tooltip: {
                    top:0,
                    trigger: 'item'
                },
                legend: {
                    // orient: 'vertical',
                    // left: 'left',
                    bottom: '10px',
                    left: 'center'
                },
                series: [
                    {
                        name: '自我评价',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: '20',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: data,
                        itemStyle: {
                            normal:{
                                color:function(params) {
                                //自定义颜色
                                    let colorList = [          
                                        '#69B4FF','#FF9B36','#E37CFD','#FF3945'
                                    ];  //定义颜色列表 方便不等长选项自行截取
                                    return colorList[params.dataIndex]
                                    }
                            }
                        }
                    }
                ]
            })
            // option && myChart.setOption(option);
        },
    },
 
  beforeDestroy() {

   
  }
};
</script>

<style >
    .flower_dia .el-dialog__footer{
        text-align: center;
    }
    .flower_dia{
        border-radius: 18px;
    }
    .studen_list_dia{
             border-radius: 18px;
    }
    .flower_dia .el-dialog__footer .el-button{
        margin:0 40px
    }
    .grade_detail_item .el-progress-circle{
        width: 142px !important;
        height: 142px !important;
    }
</style>
<style scoped>
    .wrapper{
        /* background: #F2F9FF; */
        height: calc(100vh - 152px);
        /* padding: 16px; */
        box-sizing: border-box;
        display: flex;
        /* overflow: auto; */
        flex-direction: column;
        width: 75vw;
        margin: 14px auto;
    }

    .head{
        height: 40px;
        line-height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        color:#69B4FF;
        margin-bottom: 20px;
    }
    .head img{
        display: block;
        cursor: pointer;
        width: 24px;
        height: 20px;
    }
    .report_content{
        /* background: red; */
        flex: 1;
        /* padding: 0 20px; */
        overflow:auto;
    }
    .course_info{
        background: white;
        border-radius: 12px;
        padding: 12px 24px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-bottom: 20px;
    }
    .course_AVG{
        display: flex;
        margin: 20px 0; 
        justify-content: space-between;
    }
    .head_tap{
        height: 60px;
        background: #FFFFFF;
        border-radius: 12px;
        display: flex;
        justify-content: space-between;
        margin-bottom:20px;
        
  }
  .head_tap>div{
    height: 26px;
    line-height: 26px;
    margin: 17px 0 0 0;
    border-bottom: 4px solid transparent;
    cursor: pointer;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
   
  }
  .active_head_color{
    color: #69B4FF !important;
    border-color: #69B4FF !important;
  }
  .chart_box{
      display: flex;
      justify-content: space-between;
  }
  .chart_item{
        width: 368px;
        height: 450px;
        background: #FFFFFF;
        border-radius: 12px;
  }
  /* .chart_item>div:nth-of-type(1){
        height: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1A1A1A;
        padding: 20px 0 0 20px;
  } */
  #my_evaluate{
      margin-top: 0px;
      height: 440px;
  }
  #teacher_evaluate{
      margin-top: 0px;
      height: 440px;
  }
  
  #classmate_evaluate{
      margin-top: 0px;
      height: 440px;
  }
  .student_list{
      background: #FFFFFF;
        border-radius: 12px;
        margin-top: 20px;
        padding: 20px;
        padding-top: 10px;
  }
  .student_list_box{
      display: flex;
      justify-content: space-between;
      width: 100%;
  }
  .student_item{
      width:calc(50% - 50px);
      background: #F5FAFF;
        border-radius: 12px;
        padding:20px;
        margin-bottom: 20px;
  }
  .item_box{
      margin-top: 20px;
  }
  .item_data_list{
      display: flex;
      flex-wrap: wrap;

  }
  .item_data_list >div{
    height: 30px;
    background: #E0F0FF;
    border-radius: 4px;
    line-height: 30px;
    padding: 0 20px;
    color: #54A9FD;
    margin:20px 20px 0 0;
    margin-left: 0;
  }
  .list_gui_box{
      display: flex;
      width: 100%;
      background: #FFFFFF;
      justify-content: space-between;
      padding: 20px;
      box-sizing: border-box;
      flex-wrap: wrap;
  }
  .list_gui_item{
      width: calc(50% - 60px);
      padding: 14px;
      height: 228px;
    background: #FFFFFF;
    box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
    border-radius: 6px 20px 20px 6px;
    border: 10px solid #69B4FF;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    
  }
  .list_gui_item_contnet{
      flex: 1;
      overflow: auto;
      margin: 10px 0;
  }
  .list_gui_item_time{
      text-align: right;
  }
  .list_gui_item_name{
      
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #54A9FD;
        line-height: 30px;
  }
  
   

</style>